import {environment} from '../../../environments/environment';
export const SendgridApiKey = environment.sendgridKey;








// WEBPACK FOOTER //
// C:/Clients/rent-hero/web-application/src/app/_shared/config/sendgrid.config.ts